import emailRegex from "../../emailRegex";
import textSchema from "./text";

const emailSchema = textSchema
  .matches(emailRegex, "Este campo debe ser un correo electrónico válido");

export default emailSchema;
